import { jwtDecode } from "jwt-decode";

let auth0LogoutFunction = null;

export const setAuth0Logout = (logoutFn) => {
auth0LogoutFunction = logoutFn;
};

const handleAuthError = (message) => {
console.warn(message);
localStorage.clear();
sessionStorage.clear();

if (auth0LogoutFunction) {
    auth0LogoutFunction({
    logoutParams: {
        returnTo: window.location.origin,
    },
    });
} else {
    window.location.replace("/");
}
};

const tokenValidatorInterceptor = () => ({
onFulfilled: (config) => {
    const token = localStorage.getItem("@csi/token");
    if (token) {
    try {
        const decoded = jwtDecode(token);
        const now = Date.now() / 1000;

        if (decoded.exp < now) {
        handleAuthError("Token expirado detectado antes de la petición");
        return Promise.reject(new Error("Token expirado"));
        }
    } catch (e) {
        handleAuthError("Token inválido detectado");
        return Promise.reject(new Error("Token inválido"));
    }
    }

    return config;
},
onRejected: (error) => {
    return Promise.reject(error);
},
});

export default tokenValidatorInterceptor;
